import "./TradeServices.module.css";
import Header from "@/reusable_sections/Header";
import GrowthPathways from "./sections/GrowthPathways";
import TheLogisticsNetwork from "./sections/TheLogisticsNetwork";
import ServiceLogisticsFaq from "./sections/ServiceLogisticsFaq";
import SiteFooter from "@/reusable_sections/Footer";
export default function TradeServicesPage() {
  return <div>
      <Header />
      <GrowthPathways />
      <TheLogisticsNetwork />
      <ServiceLogisticsFaq />
      <SiteFooter />
    </div>;
}